import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";

const PHRASES = [

];

const DISPLAY_DURATION = 5000;
const TRANSITION_DURATION = 500;

const InputField = ({ selectedLink }) => {
  const { t } = useLanguage()
  const navigate = useNavigate()
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [userText, setUserText] = useState("");

  const textareaRef = useRef(null);
  const containerRef = useRef(null);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);


  const goToLogin = () => {
    window.location.href = "https://t0.projecte8.com/join-waitlist";
  };

  const navigateUrlSales = () => {
    navigate("/contact/sales")
  }

  useEffect(() => {
    if (isEditing) return;

    intervalRef.current = setInterval(() => {
      setIsVisible(false);

      timeoutRef.current = setTimeout(() => {
        setPhraseIndex((prev) => (prev + 1) % t.website.phrases.length);
        setIsVisible(true);
      }, TRANSITION_DURATION);
    }, DISPLAY_DURATION);

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
    };
  }, [isEditing]);


  const activateEditing = useCallback(() => {
    setIsEditing(true);
    setTimeout(() => textareaRef.current?.focus(), 50);
  }, []);


  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      navigateUrlSales();
    }
  };


  useEffect(() => {
    if (selectedLink === 1) {
      containerRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, [selectedLink]);

  return (
    <div className="input_field_home_cont" ref={containerRef}>
      <div className="input_field_inner_cont">
        {/* <h1 className="input_field_inner_cont_title">Your business OS</h1> */}
        <h1 className="main_title_home fade-in">{t.website.main_title}</h1>
        <h3 className="main_subtitle_home fade-in">
          {t.website.main_subtitle}
        </h3>

        <div
          className={`input_field_home ${isEditing ? "editing" : ""}`}
          onClick={!isEditing ? activateEditing : undefined}
        >
          {!isEditing ? (
            <div
              className={`phrase ${isVisible ? "fade-in" : "fade-out"
                }`}
            >
              {t.website.phrases[phraseIndex]}
            </div>
          ) : (
            <textarea
              ref={textareaRef}
              className="auto_resize"
              value={userText}
              onChange={(e) => setUserText(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder={t.website.input_placeholder}
            />
          )}

          <div className="input_field_home_footer">
            <button
              className={`input_field_home_btn ${isEditing ? "input_field_home_btn_black" : ""
                }`}
              type="button"
              onClick={navigateUrlSales}
            >
              <i className="fa-solid fa-chevron-up" />
            </button>
          </div>
        </div>
        <div className="btn_input_cont">
          <button onClick={navigateUrlSales} className="input_cont_btn">{t.website.build_software}</button>
          <button onClick={navigateUrlSales} className="input_cont_btn">{t.website.create_agents}</button>
          <button onClick={navigateUrlSales} className="input_cont_btn">{t.website.fine_tune}</button>
          <button onClick={navigateUrlSales} className="input_cont_btn">{t.website.centralized_search}</button>
          <button onClick={navigateUrlSales} className="input_cont_btn">{t.website.team_orch}</button>
        </div>
      </div>
    </div>
  );
};

export default InputField;
